import axios from "axios";
const apiAdder = process.env.VUE_APP_API;
export async function getList() {
  return axios.get(`${apiAdder}account/`).then((rsp) => {
    return rsp.data;
  });
}
export async function addAccount(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}account/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function getDeviceList() {
  const token = localStorage.getItem("token");
  return axios
    .get(`${apiAdder}/device/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
